/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateStrategyRequest,
  HTTPValidationError,
  ListStrategiesParams,
  StrategyListResponse,
  StrategyResponse
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Create a new strategy (version 1).
 * @summary Create Strategy
 */
export const createStrategy = (
    createStrategyRequest: CreateStrategyRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<StrategyResponse>(
      {url: `/strategies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createStrategyRequest, signal
    },
      options);
    }




export const getCreateStrategyMutationKey = () => ['createStrategy'] as const;

export const getCreateStrategyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStrategy>>, TError,CreateStrategyMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof createStrategy>>, TError,CreateStrategyMutationVariables, TContext> => {

const mutationKey = getCreateStrategyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStrategy>>, CreateStrategyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createStrategy(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStrategyMutationResult = NonNullable<Awaited<ReturnType<typeof createStrategy>>>
    export type CreateStrategyMutationBody = CreateStrategyRequest
    export type CreateStrategyMutationError = HTTPValidationError
    export type CreateStrategyMutationVariables = {data: CreateStrategyRequest}

    /**
 * @summary Create Strategy
 */
export const useCreateStrategy = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStrategy>>, TError,CreateStrategyMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createStrategy>>,
        TError,
        CreateStrategyMutationVariables,
        TContext
      > => {
      return useMutation(getCreateStrategyMutationOptions(options));
    }
    /**
 * List latest versions of strategies visible to the current user.
 * @summary List Strategies
 */
export const listStrategies = (
    params?: ListStrategiesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<StrategyListResponse>(
      {url: `/strategies`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListStrategiesQueryKey = (params?: ListStrategiesParams,) => {
    return [
    `/strategies`, ...(params ? [params] : [])
    ] as const;
    }


export const getListStrategiesQueryOptions = <TData = Awaited<ReturnType<typeof listStrategies>>, TError = HTTPValidationError>(params?: ListStrategiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStrategies>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStrategiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStrategies>>> = ({ signal }) => listStrategies(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStrategies>>, TError, TData> & { queryKey: QueryKey }
}

export type ListStrategiesQueryResult = NonNullable<Awaited<ReturnType<typeof listStrategies>>>
export type ListStrategiesQueryError = HTTPValidationError


/**
 * @summary List Strategies
 */

export function useListStrategies<TData = Awaited<ReturnType<typeof listStrategies>>, TError = HTTPValidationError>(
 params?: ListStrategiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStrategies>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListStrategiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






